<template>
  <div class="text-left">
    <div class="row">
      <div class="col-sm-12">
        <h3 class="font-weight-bolder mt-2">Certificates</h3>
      </div>
      <div class="col-sm-12">
        <table class="table table-hover table-bordered table-template-1 table-layout-fixed text-small">
          <thead>
          <tr>
            <th :class="{'col-index': !printMultipleParams.active, 'col-date': printMultipleParams.active}">
              <input type="checkbox"
                     v-if="printMultipleParams.active"
                     @change="selectDocuments"
                     :checked="allDocumentSelected"
              >
              #
            </th>
            <th>Code</th>
            <th style="width: 30%;">Name</th>
            <th style="width: 12%">Document Number</th>
            <th>Issued Date</th>
            <th>Expiry Date</th>
            <th style="width: 100px;">Days to Expire</th>
            <!--                        <th style="width: 113px;" >Last Updated By</th>-->
            <th>Last Updated</th>
            <th style="width: 210px;">Action</th>

          </tr>
          </thead>
          <tbody>

          <tr v-if="isLoading">
            <td colspan="9">
              <app-loading></app-loading>
            </td>
          </tr>

          <template v-else>
            <tr v-for="(crewDocument, index) in crewDocuments" :key="crewDocument.id"
                :class="{
                          'bg-lightgreen' : (crewDocument.crew_document && printMultipleParams.selectedCrewDocuments.documents.includes(crewDocument.crew_document.id)) && printMultipleParams.active,
                          'text-danger': (crewDocument.crew_document && crewDocument.crew_document.expired)
                      }">

              <td class="text-right">
                <input type="checkbox" name="crew-document-selection"
                       v-if="printMultipleParams.active && (crewDocument.crew_document && crewDocument.crew_document.hasFile)"
                       :value="crewDocument.crew_document.id"
                       v-model="printMultipleParams.selectedCrewDocuments.documents"
                >
                {{ index + 1 }}
              </td>
              <td class="col-code">{{ crewDocument.code }}</td>
              <td>{{ crewDocument.name }}</td>

              <td>
                <template v-if="crewDocument.crew_document">
                  {{ crewDocument.crew_document.doc_no ? crewDocument.crew_document.doc_no : '------' }}
                </template>
              </td>

              <td>
                <template v-if="crewDocument.crew_document">
                  <template v-if="crewDocument.crew_document.issued_date">
                    {{ crewDocument.crew_document.issued_date | moment('D MMM YYYY') }}
                  </template>
                  <template v-else> ------</template>
                </template>
              </td>

              <td>
                <template v-if="crewDocument.crew_document">
                  <template v-if="crewDocument.crew_document.expiry_date">
                    {{ crewDocument.crew_document.expiry_date | moment('D MMM YYYY') }}
                  </template>
                  <template v-else> ------</template>
                </template>
              </td>

              <td>
                <template v-if="crewDocument.crew_document">
                  <template v-if="crewDocument.crew_document.expired">
                    EXPIRED
                  </template>
                  <template v-else-if="crewDocument.crew_document.daysToExpire">
                    {{ crewDocument.crew_document.daysToExpire }}
                  </template>
                  <template v-else> ------</template>
                </template>
              </td>

              <!--                        <td v-if="crewDocument.crew_document">{{ fullName(crewDocument.crew_document.uploaded_by) }}</td>-->
              <!--                        <td v-else>&#45;&#45;&#45;&#45;&#45;&#45;</td>-->

              <td v-if="crewDocument.crew_document">
                {{
                  crewDocument.crew_document.updatedAt ? crewDocument.crew_document.updatedAt : crewDocument.crew_document.uploadedAt
                }}
              </td>
              <td v-else>------</td>

              <td class="text-center">

                <button class="btn btn-sm btn-xs btn-outline-info mr-2"
                        v-if="crewDocument.crew_document"
                        data-toggle="modal"
                        data-target="#viewCrewDocument"
                        @click="updateCrewDocumentModal(crewDocument)"
                >
                  <span class="fas fa-eye"></span>
                  View
                </button>
                <template v-if="crew.active == 1 || isSystemAdmin ">
                  <button class="btn btn-sm btn-xs btn-outline-primary mr-2"
                          style="opacity: 0.75"
                          data-toggle="modal"
                          data-target="#newCrewDocument"
                          @click="refreshNewCrewDocument(crewDocument)"
                          v-if="(isDesignatedManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff) && !guest && !isKline"
                  >
                    <span class="fas fa-file-alt"></span>
                    {{ crewDocument.crew_document ? 'Renew' : 'Upload' }}
                  </button>
                  <button class="btn btn-sm btn-xs btn-outline-success mr-2"
                          v-if="crewDocument.crew_document && crewDocument.crew_document.hasFile && (isDesignatedPrincipal || isPrincipal || isPrincipalStaff) && !guest && !isKline"
                          @click="initializeDownloadCrewDocument(crewDocument)"
                          title="Download Document File"
                  >
                    <span class="fas fa-download"></span>
                  </button>
                  <button class="btn btn-sm btn-xs btn-danger"
                          v-if="crewDocument.crew_document && crewDocument.crew_document.hasFile && (isDesignatedManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff) && !guest && !isKline"
                          @click="confirmDeleteCrewDocument(crewDocument.crew_document.id)"
                          title="Delete This Document Record"
                  >
                    <span class="fas fa-trash"></span>
                  </button>
                </template>
              </td>
            </tr>

          </template>

          </tbody>

        </table>
      </div>
    </div>
    <div class="modal fade" id="newCrewDocument" tabindex="-1" role="dialog" aria-labelledby="newCrewDocumentTitle" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-centered" role="document">

        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bolder" id="newCrewDocumentTitle">
              UPLOAD NEW {{ documentTitle }}
            </h5>
            <button type="button" id="closeNewCrewDocument" class="close"
                    data-dismiss="modal" aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body text-small">
            <div class="row">
              <form class="col col-sm-4" @submit.prevent="confirmUploadCrewCertificate">

                <div class="form-group form-row mb-1" :class="{'has-error': newCrewDocumentError.doc_no}">
                  <label class="col col-sm-6 col-form-label font-weight-bolder text-left" for="newCrewDocumentNumber" >
                    Doc No:
                  </label>

                  <div class="col col-sm-12">
                    <input type="text" id="crewDocumentNumber"
                           class="form-control form-control-xs"
                           placeholder="Enter Document No. Here"
                           v-model="newCrewDocument.doc_no"
                           :required="!!doc_no"
                           v-if="doc_no"
                    >
                    <input type="text"
                           class="form-control form-control-xs"
                           readonly
                           v-else
                           :value="'N/A'"
                    />
                    <span class="help-block" v-if="newCrewDocumentError.doc_no !== ''">
                                            <small><strong>{{ newCrewDocumentError.doc_no }}</strong></small>
                                        </span>
                  </div>
                </div>
                <div class="form-check d-block text-left pl-0"  v-if="crew.country.id !==1">
                  <label class="form-check-label font-weight-bolder w-25 mb-3"
                         for="new-crew-document-no-doc-no"

                  >
                    No Doc No?
                  </label>
                  <input class="form-check-input ml-0" type="checkbox" id="new-crew-document-no-doc-no"
                         v-model="no_doc_no" @change="toggleNotRequired('no_doc_no','doc_no')"
                  >
                </div>
                <div class="form-group form-row mb-1" :class="{'has-error': newCrewDocumentError.issued_date}">
                  <label class="col col-sm-6 col-form-label font-weight-bolder text-left" for="newCrewDocumentIssue" >
                    Issued Date:
                  </label>

                  <div class="col col-sm-12">
                    <input type="date" id="crewDocumentNumber"
                           class="form-control form-control-xs"
                           v-model="newCrewDocument.issued_date"
                           :required="!!issued_date"
                           v-if="issued_date"
                    >
                    <input type="text"
                           class="form-control form-control-xs"
                           readonly
                           v-else
                           :value="'N/A'"
                    />
                    <span class="help-block" v-if="newCrewDocumentError.issued_date !== ''">
                                            <small><strong>{{ newCrewDocumentError.issued_date }}</strong></small>
                                        </span>
                  </div>
                </div>
                <div class="form-check d-block text-left pl-0"  v-if="crew.country.id !==1">
                  <label class="form-check-label font-weight-bolder w-25 mb-3"
                         for="new-crew-document-no-issued_date"

                  >
                    No Issued Date?
                  </label>
                  <input class="form-check-input ml-0" type="checkbox" id="new-crew-document-issued_date"
                         v-model="no_issued_date" @change="toggleNotRequired('no_issued_date','issued_date')"
                  >
                </div>
                <div class="form-group form-row mb-1" :class="{'has-error': newCrewDocumentError.expiry_date}">
                  <label class="col col-sm-6 col-form-label font-weight-bolder text-left" for="newCrewDocumentExpiry" >
                    Expiry Date:
                  </label>

                  <div class="col col-sm-12">
                    <input type="date" id="crewDocumentNumber"
                           class="form-control form-control-xs"
                           v-model="newCrewDocument.expiry_date"
                           :required="!!expiry_date"
                           v-if="expiry_date"
                    >
                    <input type="text"
                           class="form-control form-control-xs"
                           readonly
                           v-else
                           :value="'N/A'"
                    />
                    <span class="help-block" v-if="newCrewDocumentError.expiry_date !== ''">
                                            <small><strong>{{ newCrewDocumentError.expiry_date }}</strong></small>
                                        </span>
                  </div>
                </div>
                <div class="form-check d-block text-left pl-0"  v-if="crew.country.id !==1">
                  <label class="form-check-label font-weight-bolder w-25 mb-3"
                         for="new-crew-document-no-expiry_date"

                  >
                    No Expiry?
                  </label>
                  <input class="form-check-input ml-0" type="checkbox" id="new-crew-document-issued_date"
                         v-model="no_expiry" @change="toggleNotRequired('no_expiry','expiry_date')"
                  >
                </div>
                <div class="form-group form-row mb-1" :class="{'has-error': newCrewDocumentError.crewFile}">
                  <label class="col col-sm-6 col-form-label font-weight-bolder text-left" for="newCrewDocumentFile" >
                    File:
                  </label>

                  <div class="col col-sm-12">
                    <input type="file" id="newCrewDocumentFile" required
                           class="form-control form-control-xs"
                           accept="application/pdf"
                           :disabled="!!no_file"
                           @change="updateFileFrame"
                    >
                    <span class="help-block" v-if="newCrewDocumentError.crewFile !== ''">
                                            <small><strong>{{ newCrewDocumentError.crewFile }}</strong></small>
                                        </span>
                  </div>
                </div>
                <div class="form-check d-block text-left pl-0" v-if="crew.country.id !==1">
                  <label class="form-check-label font-weight-bolder w-25 mb-3"
                         for="new-crew-document-no-file"
                  >
                    No File?
                  </label>
                  <input class="form-check-input ml-0" type="checkbox" id="new-crew-document-no-file"
                         v-model="no_file" @change="clearNewFile('newCrewDocumentFile')"
                  >
                </div>
                <hr />
                <button type="submit" class="btn btn-sm btn-outline-primary font-weight-bolder float-right">
                  <span class="fas fa-plus"></span>
                  Save
                </button>
              </form>
              <div class="col col-sm-8">
                <span id="promptSpan"></span>
                <iframe src="" frameborder="0" height="500" width="720" id="fileFrame"></iframe>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>

    <div class="modal fade"
         id="viewCrewDocument"
         tabindex="-1"
         role="dialog"
         aria-labelledby="viewCrewDocumentTitle"
         aria-hidden="true"
    >
      <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body text-small full-modal-body-height" v-if="crewDocument.id">
            <div class="row full-modal-body-height">
              <div class="col col-sm-4" style="overflow-y: scroll;height: inherit">
                <div class="row">
                  <form class="col col-sm-12" @submit.prevent="confirmUpdateCrewDocument">

                    <div class="form-group form-row mb-1" :class="{'has-error': crewDocumentError.doc_no}">
                      <label class="col col-sm-4 col-form-label font-weight-bolder text-left" for="crewDocumentNumber" >
                        Doc No:
                      </label>

                      <div class="col col-sm-8">
                        <input type="text" id="crewDocumentNumber"
                               class="form-control form-control-xs"
                               placeholder="Enter Document No. Here"
                               v-model="crewDocument.doc_no"
                               :required="!!doc_no"
                               v-if="doc_no && editable"
                        >
                        <input type="text"
                               class="form-control form-control-xs"
                               readonly
                               v-else
                               :value="crewDocument.doc_no ? crewDocument.doc_no  : 'N/A'"
                        />
                        <span class="help-block" v-if="crewDocumentError.doc_no !== ''">
                                                    <small><strong>{{ crewDocumentError.doc_no }}</strong></small>
                                                </span>
                      </div>
                    </div>
                    <div class="form-check d-block text-left pl-0" v-if="crew.country.id !==1 && editable">
                      <label class="form-check-label font-weight-bolder w-25 mb-3"
                             for="crew-document-no-doc_no"
                      >
                        No Doc No?
                      </label>
                      <input class="form-check-input ml-0" type="checkbox" id="crew-document-no-doc_no"
                             v-model="no_doc_no" @change="updateCrewDocumentDocNo(crewDocumentId)"
                      >
                    </div>
                    <div class="form-group form-row mb-1" :class="{'has-error': crewDocumentError.issued_date}">
                      <label class="col col-sm-4 col-form-label font-weight-bolder text-left" for="crewDocumentIssue" >
                        Issued Date:
                      </label>

                      <div class="col col-sm-8">
                        <input type="date" id="crewDocumentIssue"
                               class="form-control form-control-xs"
                               v-model="crewDocument.issued_date"
                               :required="issued_date"
                               v-if="issued_date && editable"
                        >
                        <input type="text"
                               class="form-control form-control-xs"
                               readonly
                               v-else
                               :value="crewDocument.issued_date ? formatDate(crewDocument.issued_date)  : 'N/A'"
                        />
                        <span class="help-block" v-if="crewDocumentError.issued_date !== ''">
                                                    <small><strong>{{ crewDocumentError.issued_date }}</strong></small>
                                                </span>
                      </div>
                    </div>
                    <div class="form-check d-block text-left pl-0" v-if="crew.country.id !==1 && editable">
                      <label class="form-check-label font-weight-bolder w-25 mb-3"
                             for="crew-document-no-issued_date"
                      >
                        No Issued Date?
                      </label>
                      <input class="form-check-input ml-0" type="checkbox" id="crew-document-no-issued_date"
                             v-model="no_issued_date" @change="updateCrewDocumentIssuedDate(crewDocumentId)"
                      >
                    </div>
                    <div class="form-group form-row mb-1" :class="{'has-error': crewDocumentError.expiry_date}">
                      <label class="col col-sm-4 col-form-label font-weight-bolder text-left" for="crewDocumentExpiry" >
                        Expiry Date:
                      </label>

                      <div class="col col-sm-8">
                        <input type="date" id="crewDocumentIssue"
                               class="form-control form-control-xs"
                               v-model="crewDocument.expiry_date"
                               :required="expiry_date"
                               v-if="expiry_date && editable"
                        >
                        <input type="text"
                               class="form-control form-control-xs"
                               readonly
                               v-else
                               :value="crewDocument.expiry_date ? formatDate(crewDocument.expiry_date)  : 'N/A'"
                        />
                        <span class="help-block" v-if="crewDocumentError.expiry_date !== ''">
                                                    <small><strong>{{ crewDocumentError.expiry_date }}</strong></small>
                                                </span>
                      </div>
                    </div>
                    <div class="form-check d-block text-left pl-0" v-if="crew.country.id !==1 && editable">
                      <label class="form-check-label font-weight-bolder w-25 mb-3"
                             for="crew-document-no_expiry"
                      >
                        No Expiry?
                      </label>
                      <input class="form-check-input ml-0" type="checkbox" id="crew-document-no_expiry"
                             v-model="no_expiry" @change="updateCrewDocumentExpiry(crewDocumentId)"
                      >
                    </div>


                    <div class="form-group form-row mb-1" :class="{'has-error': crewDocumentError.crewFile}" v-if="editable">
                      <label class="col col-sm-4 col-form-label font-weight-bolder text-left" for="crewDocumentFile" >
                        File:
                      </label>

                      <div class="col col-sm-8">
                        <input type="file" id="crewDocumentFile"
                               class="form-control form-control-xs"
                               accept="application/pdf"
                               @change="updateViewFileFrame('crewDocumentFile')"
                               :required="!crewDocument.no_file"
                               :disabled="!!crewDocument.no_file"
                        >
                        <span class="help-block" v-if="crewDocumentError.crewFile !== ''">
                                                    <small><strong>{{ crewDocumentError.crewFile }}</strong></small>
                                                </span>
                      </div>
                    </div>
                    <div class="form-check d-block text-left pl-0 mb-3" v-if="editable">
                      <label class="form-check-label font-weight-bolder w-25 mr-2"
                             for="new-crew-document-no-file"
                      >
                        N/A
                      </label>
                      <input class="form-check-input ml-4" type="checkbox" id="new-crew-document-no-file"
                             v-model="crewDocument.no_file"
                             @change="clearFileinput('crewDocumentFile')"
                      >
                    </div>

                    <div class="form-group form-row mb-1">
                      <label class="col col-sm-4 col-form-label font-weight-bolder text-left">
                        Uploaded By:
                      </label>

                      <div class="col col-sm-8">
                        <input type="text" class="form-control form-control-xs" readonly
                               placeholder="Uploaded By"
                               v-model="crewDocument.uploadedBy"
                        >
                      </div>
                    </div>

                    <div class="form-group form-row mb-1">
                      <label class="col col-sm-4 col-form-label font-weight-bolder text-left">
                        Uploaded At:
                      </label>

                      <div class="col col-sm-8">
                        <input type="text" class="form-control form-control-xs" readonly
                               placeholder="Uploaded At"
                               v-model="crewDocument.uploadedAt"
                        >
                      </div>
                    </div>

                    <div class="form-group form-row mb-1">
                      <label class="col col-sm-4 col-form-label font-weight-bolder text-left">
                        Updated By:
                      </label>

                      <div class="col col-sm-8">
                        <input type="text" class="form-control form-control-xs" readonly
                               placeholder="NOT UPDATED YET"
                               v-model="crewDocument.updatedBy"
                        >
                      </div>
                    </div>

                    <div class="form-group form-row mb-1">
                      <label class="col col-sm-4 col-form-label font-weight-bolder text-left">
                        Updated At:
                      </label>

                      <div class="col col-sm-8">
                        <input type="text" class="form-control form-control-xs" readonly
                               placeholder="Updated At"
                               v-model="crewDocument.updatedAt"
                        >
                      </div>
                    </div>

                    <hr />

                    <template v-if="crew.active == 1 || isSystemAdmin">
                      <template v-if="(isDesignatedManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff) && !guest">
                        <button type="reset" v-if="editable"
                                @click.prevent="cancelEdit"
                                class="btn btn-sm btn-xs btn-secondary font-weight-bolder float-right"
                        >
                          CANCEL
                        </button>

                        <button type="submit" class="btn btn-sm btn-xs btn-warning font-weight-bolder float-right mr-2">
                          <span class="fas fa-edit"></span>
                          {{ editable ? 'UPDATE': 'EDIT' }}
                        </button>
                      </template>
                    </template>


                  </form>
                  <div class="col col-sm-12 p-3">
                    <h5 class="font-weight-bold">History</h5>
                    <table class="table table-hover table-bordered table-template-1 table-layout-fixed text-small">
                      <thead>
                      <tr>
                        <th class="p-2 col-index">#</th>
                        <th class="p-2">Last Updated At</th>
                        <th class="p-2">Updated By</th>
                        <template v-if="crew.active == 1">
                          <th class="p-2" style="width: 10%;"
                              v-if="(isDesignatedManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff) && !guest"
                          >Del</th>
                        </template>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(documentHistory, index) in crewDocumentHistory"
                          :key="documentHistory.id"
                          :class="{ 'bg-selected': documentHistory.id === crewDocument.id, 'cursor-pointer': documentHistory.id !== crewDocument.id }"
                          @click="getCrewDocumentHistoryRecord(documentHistory)"
                      >

                        <td>{{ index + 1 }}</td>
                        <td>
                          {{ documentHistory.updatedAt ? documentHistory.updatedAt : documentHistory.uploadedAt }}
                        </td>
                        <td>{{ documentHistory.updatedBy ? documentHistory.updatedBy : documentHistory.uploadedBy }}</td>
                        <template v-if="crew.active == 1">
                          <td v-if="(isDesignatedManning || isDesignatedPrincipal || isPrincipal || isPrincipalStaff) && !guest">
                            <button class="btn btn-outline-danger btn-xs"
                                    title="Delete this Document record"
                                    @click="confirmDeleteCrewDocumentHistory(documentHistory.id, documentHistory.documentId)"
                            >
                              <i class="fas fa-trash"></i>
                            </button>
                          </td>
                        </template>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="col col-sm-8 border-left">
                <div class="modal-header">
                  <h5 class="modal-title font-weight-bolder mx-auto" id="viewCrewDocumentTitle">
                    {{ documentTitle }}
                  </h5>
                  <button type="button" id="closeViewCrewDocument" class="close p-0"
                          style="margin-left: -60px !important;"
                          @click="cancelEdit"
                          data-dismiss="modal" aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <iframe :src="crewDocumentFile" frameborder="0" width="720" id="certFrame"
                        class="full-height"
                        v-if="crewDocumentFile"
                ></iframe>

                <div class="alert alert-danger" role="alert"
                     v-else
                >
                  {{  editFilePrompt }}
                </div>
              </div>
            </div>

          </div>

        </div>

      </div>
    </div>
  </div>

</template>

<script>

import {vueAppMixin} from "@/mixins/vueAppMixin";
import {dataMixin} from "@/mixins/dataMixin";
import {crewDocumentMixin} from "@/mixins/crewDocumentMixin";
import {gateMixin} from "@/mixins/gateMixin";

export default {
  name: "CrewCertificate",
  mixins: [vueAppMixin, dataMixin, crewDocumentMixin, gateMixin],
  created() {
    let params = {
      crewId: this.crew.id,
      docType: 3
    };
    this.getCrewDocuments(params);
    this.refreshNewCrewDocument();
  }
}
</script>

<style scoped>
* {
  font-family: 'Nunito', sans-serif;
}

.table-template-1 td, .table-template-1 {
  text-align: center;
}

.table-template-1 td:nth-child(3) {
  text-align: left;
}
</style>
